import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import EmojiPicker from '../../../../communication/messages/emojiPicker/empjiPicker';
import { QUILL_API_ACTION_ADD_EMOJI } from '../../creatorTextEditor/config';
import QuillEditor from './quillEditor';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';

const TextEditorCard = ({
  title,
  showEmoji = false,
  editorContent,
  setEditorContent,
  quillText
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { lomavisCreatorConfig } = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  const mentionConfigUrls = Object.values(
    lomavisCreatorConfig?.mention_search_urls || {}
  );

  const [editor, setEditor] = useState(null);

  const addEmoji = (emoji) => {
    if (editor) {
      editor.insertText(
        editor.getSelection(true).index,
        emoji,
        QUILL_API_ACTION_ADD_EMOJI
      );
    }
  };

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  return (
    <div className="w-100 d-flex card mb-1">
      <div>
        <QuillEditor
          value={editorContent?.text}
          onChange={handleEditorChange}
          mentionConfigUrls={mentionConfigUrls}
          editor={editor}
          setEditor={setEditor}
          quillText={quillText}
        />
      </div>

      {showEmoji && (
        <div className="d-flex justify-content-between mt-2">
          <div className="d-flex align-items-center gap-1">
            <EmojiPicker addEmoji={addEmoji} />
          </div>
        </div>
      )}
    </div>
  );
};

export default TextEditorCard;
